
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "configuration"
    }}>{`Configuration`}</h1>
    <p>{`Apart from `}<a parentName="p" {...{
        "href": "/docs/theming"
      }}>{`theming`}</a>{`, VCC UI ships another context provider which is used for configuration.
It can be used to configure custom rendering logic.`}</p>
    <h2 {...{
      "id": "locale"
    }}>{`locale`}</h2>
    <p>{`Some VCC UI features are language specific. By passing a `}<inlineCode parentName="p">{`locale`}</inlineCode>{` to the `}<inlineCode parentName="p">{`ConfigProvider`}</inlineCode>{`, Volvo Fonts will not be included for unsupported languages, and the theme direction will be automatically set.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react';
import { ConfigProvider } from 'vcc-ui';

export const App = () => {
  const locale = getCurrentLocale();
  return (
    <ConfigProvider config={{ locale }}>
      <MyPage />
    </ConfigProvider>
  );
};
`}</code></pre>
    <h2 {...{
      "id": "linkcomponent"
    }}>{`linkComponent`}</h2>
    <p>{`By default, every component accepting a `}<inlineCode parentName="p">{`href`}</inlineCode>{` prop will render a respective `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` tag. However, many web frameworks, e.g. `}<a parentName="p" {...{
        "href": "https://nextjs.org"
      }}>{`Next.js`}</a>{`, provide a custom `}<inlineCode parentName="p">{`Link`}</inlineCode>{` component that is used for client-side routing.
Instead of wrapping every linkable component with that `}<inlineCode parentName="p">{`Link`}</inlineCode>{` component, we can configure the `}<inlineCode parentName="p">{`linkComponent`}</inlineCode>{` using the `}<inlineCode parentName="p">{`ConfigProvider`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import React from 'react';
import { ConfigProvider, Link } from 'vcc-ui';
import NextLink from 'next/link';

const config = {
  linkComponent: ({ children, href, ...linkProps }) => {
    // we only want to use next/link for internal links
    // external links are better served with an basic a tag
    if (typeof href === 'object' || href.indexOf('/') === 0) {
      return (
        <NextLink href={href}>
          <a {...linkProps}>{children}</a>
        </NextLink>
      );
    }

    return (
      <a href={href} {...linkProps}>
        {children}
      </a>
    );
  },
};

export const App = () => (
  <ConfigProvider config={config}>
    <Link href="/subpage">Go to sub page</Link>
  </ConfigProvider>
);
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;